module.exports = __webpack_public_path__ + "static/media/temperature-frigid.8b893e87.svg";